<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon error">
      <i class="fa-solid fa-triangle-exclamation"></i>
    </div>
    <div>
      <h2 class="dialog-title">Media file spec check failed</h2>
      <p class="dialog-subtitle" style="cursor: pointer;" [cdkCopyToClipboard]="dialogData.title" (click)="onCopyToClipboard(dialogData.title)">{{ dialogData.title | uppercase }}</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onClose()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  @if (hasFailed) {
    <div class="rejection-explain">
      <strong>¿What Happened?</strong> The uploaded media file does not conform with the network's requirements. 
      Please review the issues in red and ask your team to fix the file before reuploading.
    </div>
  }

  <div class="spec-table-wrapper">
    <table class="spec-table">
      <thead>
        <tr>
          <th>Characteristic</th>
          <th>Your File</th>
          <th>Required</th>
          <th style="width:30px"></th>
        </tr>
      </thead>
      <tbody>
        @for (err of specErrors; track err) {
          <tr>
            <td class="spec-name">{{ err.parameter }}</td>
            <td>
              <span [class]="err.passed ? 'spec-ok' : 'spec-fail'">
                <i [class]="err.passed ? 'fa-solid fa-check' : 'fa-solid fa-xmark'"></i>
                {{ err.detected }}
              </span>
            </td>
            <td class="spec-req">{{ err.required }}</td>
            <td [style.color]="err.passed ? 'var(--green-dot)' : 'var(--red-dot)'">
              <i [class]="err.passed ? 'fa-solid fa-check' : 'fa-solid fa-xmark'"></i>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onViewSpecsGuide()">
    <i class="fa-solid fa-book"></i>
    View Specs Guide
  </button>
  @if (hasFailed) {
    <button class="btn-blue" (click)="onUploadNewVersion()" [disabled]="!dialogData.allowUpload">
      <i class="fa-solid fa-upload"></i>
      Upload New Version
    </button>
  }
  <!-- @if (!hasFailed) {
    <button class="btn-blue" (click)="onClose()">
      <i class="fa-solid fa-check"></i>
      Cerrar
    </button>
  } -->
</mat-dialog-actions>
